import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import { authApi } from '~services/api/auth';
import { loginMatchers, registerMatchers } from '~services/api/auth/matchers';
import { isSafeApp } from '~shared/utils/host';
import { safeModeModalActions } from '~store/safe-mode-modal';

import type { RootState } from '../index';

export const nsfwModalAuthListener = createListenerMiddleware();

nsfwModalAuthListener.startListening({
	matcher: isAnyOf(
		authApi.endpoints.authenticate.matchFulfilled,
		...registerMatchers,
		...loginMatchers
	),
	effect: (_, listenerApi) => {
		if (typeof window === 'undefined' || isSafeApp) {
			return;
		}

		const {
			safeModeModal: { shownForRegistered, shownForDemo },
		} = listenerApi.getState() as RootState;

		if (shownForDemo && !shownForRegistered) {
			listenerApi.dispatch(safeModeModalActions.showForRegistered());
		}
	},
});
